<template>
  <div class="new-password-form">
    <password-strength @change="setPasswordAndStrength"/>
    <label for="passwordConfirmation" class="new-password-form__label">
      {{ $t('login.confirm-new-password') }}
    </label>
    <password-eye
      id="passwordConfirmation"
      type="password"
      v-model="passwordConfirmation"
      :state="$bsStateValidator($v.passwordConfirmation.$error)"
      @blur.native="$v.passwordConfirmation.$touch()"
      maxlength="20"
    />
    <b-button
      id="redefinePassword"
      variant="primary"
      class="new-password-form__redefine-btn"
      block
      @click="saveNewPassword"
      :disabled="!canSave()"
    >
      {{ $t('login.redefine-password') }}
    </b-button>
    <p
      class="new-password-form__why-info"
    >
      {{ $t('login.why-need-do-that') }}
      <i
        aria-hidden="true"
        class="fas fa-info-circle new-password-form__why-info-icon"
        id="new-password-form__why-info-icon"
      />
    </p>
    <b-tooltip
      target="new-password-form__why-info-icon"
      placement="topright"
    >
      {{ $t('login.why-need-do-that-text') }}
    </b-tooltip>
    <b-tooltip
        target="passwordConfirmation"
        placement="topright"
        triggers=""
        :show="$v.passwordConfirmation.$error && !$v.passwordConfirmation.confirmValue"
      >
      <span v-html="$t('my-data.password-modal.wrong-confirmation')"></span>
    </b-tooltip>
  </div>
</template>
<style lang="sass" scoped>
  @import "src/styles/defaults/variables"
  @import "src/styles/defaults/mobile-first"

  .new-password-form
    &__label
      margin-top: 15px
      font-weight: 600
    &__redefine-btn
      margin-top: 20px
      font-weight: 600
      white-space: normal
    &__why-info
      text-align: center
      margin-top: 20px
      font-size: .8rem
    &__why-info-icon
      color: $color-link
      margin-left: 5px
      font-size: 1.05rem
    +media-min-sm()
    +media-min-md()
    +media-min-lg()
</style>

<script>
import { mapGetters } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import PasswordEye from '@/components/inputs/PasswordEye';
import PasswordStrength from '@/components/passwordStrength/Field';
import { STRENGTH } from '@/services/passwordStrengthCalculator';
import UserService from '@/domain/services/user';
import AuthenticationService from '@/services/authentication';

export default {
  components: {
    PasswordEye,
    PasswordStrength,
  },
  data() {
    return {
      password: '',
      passwordConfirmation: '',
      passwordStrength: STRENGTH.weak,
    };
  },
  validations: {
    password: {
      required,
    },
    passwordConfirmation: {
      required,
      confirmValue(value) { return value === this.password; },
    },
  },
  methods: {
    setPasswordAndStrength(password, strength) {
      this.password = password;
      this.passwordStrength = strength;
    },
    canSave() {
      return this.$v.password.required
        && this.passwordStrength > STRENGTH.weak
        && this.$v.passwordConfirmation.required;
    },
    saveNewPassword() {
      if (this.password !== this.passwordConfirmation
        || this.passwordStrength <= STRENGTH.weak) {
        this.$pushAlert({
          code: 'MA002',
        });
        return;
      }

      UserService.changeTemporaryPassword(
        this.password,
      )
        .then(() => this.$pushAlert({ code: 'MS002' }))
        .then(() => this.proceedToNextStep());
    },
    async proceedToNextStep() {
      if (!await this.confirmSecretQuestionRegistration()) {
        return AuthenticationService.logout();
      }

      return this.$router.push({ name: 'register-secret-question' });
    },
    confirmSecretQuestionRegistration() {
      if (this.temporaryAccessData.hasSecretQuestion) {
        return this.$confirmMessage({ code: 'MC002' }).toBool();
      }
      if (!this.isOffLineMode) {
        return this.$confirmMessage({ code: 'MC003' }).toBool();
      }

      return Promise.resolve(true);
    },
  },
  computed: {
    ...mapGetters([
      'temporaryAccessData',
      'isOffLineMode',
    ]),
  },
};
</script>
